export function getQueryStringExceptingParams(paramsToIgnore) {
    const urlSearchParams = new URLSearchParams(document.location.search);
    if (urlSearchParams.size < 1) {
        return "";
    }

    if (Array.isArray(paramsToIgnore) && paramsToIgnore.length > 0) {
        Object.values(paramsToIgnore)
        .forEach(param => urlSearchParams.delete(param));
    }

    return urlSearchParams.toString();
}